import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { SecurityService, SecurityUser } from '../security/security.service';
import { MsalService } from '@azure/msal-angular';
import { ConfigService } from '../configHelper';
import { CommonModule } from '@angular/common';
import { MenubarModule } from 'primeng/menubar';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
  imports: [CommonModule, MenubarModule, RouterModule]
})
export class NavMenuComponent implements OnInit {
  currentUser: SecurityUser = new SecurityUser();
  isAuthenticated: boolean;
  isExpanded = false;
  currentUrl: string;
  items: MenuItem[];

  constructor(private _router: Router,
    public authService: MsalService,
    public securityService: SecurityService,
    private configService: ConfigService) {
    this.currentUrl = _router.url;
    this.securityService.getCurrentUser().subscribe((usr: any) => {
      this.currentUser = usr;
    });
  }

  async ngOnInit(): Promise<any> {
    await this.authService.instance.initialize();

    const account = this.authService.instance.getAllAccounts()[0];
    console.log('LT account 1 db', account);

    await this.authService.instance.handleRedirectPromise().then((res) => {
      const account = this.authService.instance.getAllAccounts()[0];
      console.log('LT account 2 db', account);
      if (res != null && res.account != null) {
        console.log('handleRedirectPromise response', res);
        this.authService.instance.setActiveAccount(res.account);
      }
    });

    this.isAuthenticated = this.authService.instance.getAllAccounts().length > 0;
    console.log('is authenticated db', this.isAuthenticated);
    if (this.isAuthenticated) {
      if (this.securityService.currentUser.UserName == account.username) {
        this.currentUser = this.securityService.currentUser;
      }
      else {
        this.securityService.loadCurrentUser().then((data: any) => {
          console.log('loadCurrentUser db', data);
          this.currentUser = data;
          this.loadMenu();
        });
      }
    }
  }

  public getTopLogo() {
    let isInterVenn: boolean = this.configService.getConfig().isInterVenn;

    if (isInterVenn) {
      return "../assets/intervenn-logo-full.svg";
    }
    else {
      return "../assets/accessdx_logo_top.jpg";
    }
  }

  async logout() {
    const account = this.authService.instance.getAllAccounts()[0];

    this.securityService.logout();
    this.authService.logoutRedirect({ account: account });
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  loadMenu() {
    let isInterVenn: boolean = this.configService.getConfig().isInterVenn;

    this.items = [
      {
        label: 'Receiving',
        icon: 'fal fa-ambulance fa-2x',
        visible: this.securityService.hasClaim('Package_View'),
        items: [
          {
            label: 'Receive',
            icon: 'fal fa-hand-holding-box fa-2x',
              routerLink: '/package-receive-new/package-receive-scan',
            visible: this.securityService.hasClaim('Package_Create') && !isInterVenn
          },
          {
            label: 'Open',
            icon: 'fal fa-box-open fa-2x',
            routerLink: '/package-open',
            visible: this.securityService.hasClaim('Package_Open') && !isInterVenn
          },
          {
            label: 'Requisition List',
            icon: 'fal fa-list fa-2x',
            routerLink: '/requisition-list',
            visible: this.securityService.hasClaim('Package_View')
          },
          {
            label: 'Package List',
            icon: 'fal fa-th-list fa-2x',
            routerLink: '/package-list',
            visible: this.securityService.hasClaim('Package_View') && !isInterVenn
          },
          {
            label: 'Receiving List',
            icon: 'fal fa-th-list fa-2x',
            routerLink: '/intervenn-receiving',
            visible: this.securityService.hasClaim('Package_View') && isInterVenn
          }
        ]
      },
      {
        label: 'Resolve',
        icon: 'fal fa-allergies  fa-2x',
        visible: this.securityService.hasClaim('Resolve_View'),
        items: [
          {
            label: 'Load Rack',
            icon: 'far fa-flux-capacitor fa-2x',
            routerLink: '/resolve-rack-load',
            visible: this.securityService.hasClaim('Resolve_Edit') && !isInterVenn
          },
          {
            label: 'Exceptions',
            icon: 'fal fa-briefcase-medical fa-2x',
            routerLink: '/packageException-list',
            visible: this.securityService.hasClaim('Resolve_View')
          },
          {
            label: 'Resolved',
            icon: 'fas fa-hand-holding-medical fa-2x',
            routerLink: '/resolvedException-list',
            visible: this.securityService.hasClaim('Resolve_View')
          },
          {
            label: 'Unload Rack',
            icon: 'fal fa-flux-capacitor fa-2x',
            routerLink: '/resolve-rack-unload',
            visible: this.securityService.hasClaim('Resolve_Edit') && !isInterVenn
          },
          {
            label: 'Rack List',
            icon: 'fal fa-th-list fa-2x',
            routerLink: '/rack-list',
            visible: this.securityService.hasClaim('Resolve_View') && !isInterVenn
          }
        ]
      },
      {
        label: 'Lab',
        icon: 'far fa-flask  fa-2x',
        visible: this.securityService.hasClaim('Lab_View'),
        items: [
          {
            label: 'Result Batches',
            icon: 'fal fa-vials fa-2x',
            routerLink: '/rawResultBatch-list',
            visible: this.securityService.hasClaim('Lab_View') && !isInterVenn
          }, {
            label: 'UTI Accession',
            icon: 'fal fa-file-csv fa-2x',
            routerLink: '/upload-strand-file',
            visible: this.securityService.hasClaim('Lab_View') && !isInterVenn
          }, {
            label: 'pTau Results',
            icon: 'fal fa-file-csv fa-2x',
            routerLink: '/upload-ptau-result',
            visible: this.securityService.hasClaim('Lab_View') && !isInterVenn
          }, {
            label: 'GlycoKnow Results',
            icon: 'fal fa-file-csv fa-2x',
            routerLink: '/upload-intervenn-result',
            visible: this.securityService.hasClaim('Lab_View') && isInterVenn
          },
        ]
      },
      {
        label: 'Report',
        icon: 'far fa-file-medical fa-2x',
        visible: this.securityService.hasClaim('Reporting_View'),
        items: [
          {
            label: 'Upload Send Out Results',
            icon: 'fal fa-file-pdf fa-2x',
            routerLink: '/uploadSendOutResults-list', //routerLink: '/reportingSendOutResults-process',
            visible: this.securityService.hasClaim('Reporting_Upload_PDF')
          },
          {
            label: 'Final Report Approval',
            icon: 'fal fa-file-signature fa-2x',
            routerLink: '/signResults-list', 
            visible: this.securityService.hasClaim('Reporting_Upload_PDF')
          }
        ]
      },
      {
        label: 'Billing',
        icon: 'far fa-file-medical fa-2x',
        visible: this.securityService.hasClaim('Bill_View'),
        items: [
          {
            label: 'Requisition List',
            icon: 'fal fa-list fa-2x',
            routerLink: '/billing-list',
            visible: this.securityService.hasClaim('Bill_View')
          },
          {
            label: 'Billing Report',
            icon: 'fal fa-file-excel fa-2x',
            routerLink: '/billing-report',
            visible: this.securityService.hasClaim('Bill_View')
          }
        ]
      },
      {
        label: 'Admin',
        icon: 'fal fa-cogs  fa-2x',
        visible: this.securityService.hasClaim('LabAdmin_View'),
        routerLink: '/lab-admin'
      }
    ];
  }

}
